import React, { useEffect, useState, useRef } from 'react';
import { AssignmentStatus, Rider, TreatmentModel, TreatmentType } from '../models/superbit-api-models';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faTelegram, IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { faBan, faBell, faCheck, faCircle, faCircleCheck, faCircleExclamation, faCircleHalfStroke, faClock, faList, faPaperclip, faPhone, faRectangleXmark, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Dropdown, MenuProps, Select, Tooltip } from 'antd';
import { tr } from 'date-fns/locale';
import { RiderModel } from '../models/superbit-api-models'
import { SimulatorModel } from '../models/SimulatorModel';
import RiderItem from './_RiderItem';
import { useNavigate } from 'react-router-dom';
import { CustomerCardModel } from '../models/CustomerCardModel';
import SignMessagePopUp from './_SignMessagePopUp';
import { setCreateTreatmentFrom } from '../app-context/tasksSlice';
import { setSueInsuranceCompanyId } from '../app-context/suesSlice';
import { useDispatch } from 'react-redux';
import { ProductionModel } from '../models/ProductionModel';
import "./_SignsTable.css";
import { cloneDeep } from 'lodash';



type Props = {
    borderBold?: boolean;
    details: any;
    statuses?: any[];
    config: any;
    actions: any;
    setRiderToPopup: Function;
    onUpdatePaymentsClick: Function;
    onActivateRiderClick: Function;
    index: number;
    setSigningSeen: Function;
    showOnlyOpens: boolean;
    actionBtns: boolean;
    handleCheckBoxRiderChange: (e: any, index: number, riderId?: string) => void;
};


const SigningItem = (props: Props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [signingItem, setSigningItem] = useState<any>(props.details);
    const [oldSigningItem, setOldSigningItem] = useState<any>(cloneDeep(props.details));
    const signingItemRef = useRef<any>(props.details);
    const [riderItem, setRiderItem] = useState<any | null>(null);
    const [signingMenuOptions, setSigningMenuOptions] = useState<MenuProps['items']>([]);
    const [riderMenuOptions, setRiderMenuOptions] = useState<MenuProps['items']>([]);
    const [apiUrl, setApiUrl] = useState<string>('');
    const [additionalColumns, setAdditionalColumns] = useState<any>(props.config.additionalColumns);
    const [statusId, setStatusId] = useState<string>('0');
    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [showOnlyRiders, setShowOnlyRiders] = useState<boolean>(false);


    const [productionCheck, setProductionCheck] = useState<boolean>(false);
    const [collectionCheck, setCollectionCheck] = useState<boolean>(false);
    const [documentsCheck, setDocumentsCheck] = useState<boolean>(false);
    const [lackOfClaimsCheck, setLackOfClaimsCheck] = useState<boolean>(false);
    const [protectionCheck, setProtectionCheck] = useState<boolean>(false);
    const [sendingToCustomerCheck, setSendingToCustomerCheck] = useState<boolean>(false);

    const [hasChanges, setHasChanges] = useState<boolean>(false);
    const [changesSaved, setChangesSaved] = useState<boolean>(false);

    const [showErrorPopUp, setShowErrorPopUp] = useState<boolean>(false);

    const [changeComments, setChangeComments] = useState<any>({
        premiumSum: '',
        productionStep: '',
        collectionStep: '',
        protectionStep: '',
        lackOfClaimsStep: '',
        documentsStep: '',
        sendingToCustomerStep: '',
        status: '',
    });


    const isValidUrl = (input: string): boolean => {
        const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?.*)?(#.*)?$/i;
        return urlPattern.test(input);
    }

    const isHTML = (str: string): boolean => {
        const htmlPattern = /<\/?[a-z][\s\S]*>/i;
        return htmlPattern.test(str);
    }

    const downloadDocument = (docUrl: string | undefined) => {
        if (apiUrl !== '' && docUrl) {
            const fileUrl = `${apiUrl}${docUrl}`;
            console.log('downloadDocument', fileUrl);
            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            anchor.target = '_blank';
            anchor.download = 'filename.pdf'; // Set the filename you want
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    const onRedirectToClient = async () => {
        let customer_info: any = null;
        const res = await new CustomerCardModel().filter({
            "filterSearch": {
                "property": "Identifier",
                "searchText": signingItem.identifier
            },
            "page": 1
        } as any);
        if (res && res.customers && res.customers.length > 0) {
            customer_info = res.customers[0];
        }
        const savedTabsStr = localStorage.getItem('clientsOpenTabs');
        let savedTabs: any[] = [];
        if (savedTabsStr) {
            savedTabs = JSON.parse(savedTabsStr);
        }
        const existingTab = savedTabs.find(t => t.id === customer_info.id);
        if (existingTab) {
            // Tab already exists, no need to add again
            navigate(`/Clients/`);
            return;
        }
        // Add new tab
        const tContent: any = {
            type: "editCustomer",
            title: customer_info.fullName,
            id: customer_info.id,
            mode: 1,
            editData: undefined,
            loaded: false
        }
        savedTabs.push(tContent);
        localStorage.setItem('clientsOpenTabs', JSON.stringify(savedTabs));

        navigate(`/Clients/`);
    }


    const onMenuClicked = (type: string) => {
        switch (type) {
            case 'edit':
                console.log('editTask');
                if (props.actions.edit) {
                    // props.actions.edit(signingItem.id);
                }
                break;
            case 'delete':
                console.log('editTask');
                if (props.actions.delete) {
                    props.actions.delete(signingItem.id);
                }
                break;
            case 'assignToHandler':
                if (props.actions.onAssignToHandler) {
                    props.actions.onAssignToHandler(signingItem.id);
                }
                break;
            case 'redirectToClient':
                onRedirectToClient();

                break;

            default:
                break;
        }
    }

    const onSelectSigning = () => {
        if (props.actions && props.actions.onSelectSigning) {
            props.actions.onSelectSigning(signingItem.id);
        }
    }

    const addSigningComment = (comment: string) => {
        if (props.actions && props.actions.addSigningComment) {
            const data = {
                "TreatmentType": 4,
                "AlertDate": moment().format('YYYY-MM-DDTHH:mm'),
                "Topic": comment,
                "PolicyRelatedId": signingItem.policyId,
                'Seen': true
            }
            props.actions.addSigningComment(data);
        }
    }

    const onRowClick = (e: any) => {
        console.log('onRowClick')
        if (e.target.parentElement.className.indexOf('cell') >= 0) {
            if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
                e.target.className == 'action-btn-menu-item pointer' ||
                e.target.className == 'ant-select-selection-item' ||
                e.target.className == 'ant-select-item-option-content' ||
                e.target.className == 'icon paperclip pointer' ||
                e.target.className == 'pointer checkbox' ||
                e.target.className == 'description bold cell-value phone-number' ||
                e.target.className == 'cell client-id' ||
                e.target.parentElement.className == 'cell client-id' ||
                e.target.parentElement.className == 'cell actions' ||
                e.target.parentElement.className == 'license-id' ||
                e.target.parentElement.className.indexOf('on-click-ignore') > 0
            ) return;

            if (getSeen()) {
                props.setSigningSeen(signingItem.id)
            }
            onSelectSigning();
        }

    }

    const onRiderRowClick = (e: any) => {

        var model = new RiderModel();
        console.log('onRiderRowClick-props.details', props.details)
        model.id = props.details.riderId;
        console.log('onRiderRowClick-model.id', model.id)
        props.setRiderToPopup(model);
    }

    const onUpdatePaymentsClick = (e: any) => {

        var model = new RiderModel();
        model.id = props.details.riderId;
        props.onUpdatePaymentsClick(model);
    }


    const onActivateRiderClick = (e: any) => {

        props.onActivateRiderClick(props.details.riderId);
    }



    const displayCarLicense = () => {
        if (signingItem.vehicle && signingItem.vehicle.licenseNumber && signingItem.vehicle.licenseNumber !== '') {
            const license = signingItem.vehicle.licenseNumber
            const cleaned = license.replace(/\D/g, "");
            return cleaned;
            // if (cleaned.length == 8)  {
            //     return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 5)}-${cleaned.slice(5)}`; // Format as XXX-XXX
            // } else {
            //     return cleaned;
            // }
        }
    }


    const onStatusChange = (value: string) => {
        if (value == '0') {
            return;
        }
        const currentData = { ...signingItem };
        if (value == '4417fea8-6401-4125-97fc-d3281bb79306' && currentData && (!currentData.policyNumber || currentData.policyNumber == '')) {
            setShowErrorPopUp(true);
            return;
        }
        // if (props.statuses) {
        //     let prevStatus = props.statuses.find((s: any) => s.value === currentData.elementaryPolicyStatusId);
        //     if (!prevStatus) {
        //         prevStatus = {
        //             value: 0,
        //             label: 'חדש'
        //         }
        //     }
        //     let newStatus = props.statuses.find((s: any) => s.value === value);
        //     if (!newStatus) {
        //         newStatus = {
        //             value: 0,
        //             label: 'חדש'
        //         }
        //     }
        //     console.log('onStatusChange prevStatus', prevStatus, 'newStatus', newStatus)
        //     const comment = `סטטוס שונה מ- ${prevStatus.label} ל-${newStatus.label}`;
        //     console.log('onStatusChange-comment', comment)
        //     const changeCommentsTemp = { ...changeComments, status: comment };
        //     setChangeComments(changeCommentsTemp);
        // }
        setStatusId(value);
        const updated = { ...currentData, elementaryPolicyStatusId: value };
        signingItemRef.current = updated;
        setSigningItem(updated);
        setHasChanges(true);
        buildMenuOptions();
    }

    const handleCheckChange = (name: string, event: any) => {
        const value = event.target.checked;
        let comment = '';
        comment += ` ${value ? 'סומן ' : 'בוטל '}`;

        switch (name) {
            case 'productionStep':
                setProductionCheck(value);
                comment += `הפקה`;
                break;
            case 'collectionStep':
                setCollectionCheck(value);
                comment += `גביה`;
                break;
            case 'protectionStep':
                setProtectionCheck(value);
                comment += `מיגון`;
                break;
            case 'lackOfClaimsStep':
                setLackOfClaimsCheck(value);
                comment += `ה. תביעות`;
                break;
            case 'documentsStep':
                setDocumentsCheck(value);
                comment += `מסמכים`;
                break;
            case 'sendingToCustomerStep':
                setSendingToCustomerCheck(value);
                comment += `שליחה`;
                break;

            default:
                break;
        }
        let changeCommentsTemp = changeComments;
        changeCommentsTemp[name] = comment;
        setChangeComments(changeCommentsTemp);

        // Update both state and ref to ensure we have the latest data
        setSigningItem((prev: any) => {
            const updated = {
                ...prev,
                [name]: value ? true : false
            };
            signingItemRef.current = updated;
            return updated;
        });

        setHasChanges(true);
    }

    const onSaveChanges = async () => {
        // Use the ref to get the absolute latest state, even if React hasn't finished batching updates
        const currentSigningItem = signingItemRef.current;
        console.log('onSaveChanges-changeComments', changeComments);
        if (currentSigningItem.elementaryPolicyStatusId !== oldSigningItem.elementaryPolicyStatusId && props.statuses) {
            let prevStatus = props.statuses.find((s: any) => s.value === oldSigningItem.elementaryPolicyStatusId);
            if (!prevStatus) {
                prevStatus = {
                    value: 0,
                    label: 'חדש'
                }
            }
            let newStatus = props.statuses.find((s: any) => s.value === currentSigningItem.elementaryPolicyStatusId);
            if (!newStatus) {
                newStatus = {
                    value: 0,
                    label: 'חדש'
                }
            }
            const comment = `סטטוס שונה מ- ${prevStatus.label} ל-${newStatus.label}`;
            console.log('onStatusChange-comment', comment)
            let changeCommentsTemp = changeComments;
            changeCommentsTemp.status = comment;
            setChangeComments(changeCommentsTemp);
        }

        if (props.actions && props.actions.update) {
            props.actions.update(currentSigningItem);
            Object.entries(changeComments).forEach(([key, value]) => {
                console.log(`${key}: ${value}`);
                if (value && typeof value === 'string' && value.length > 0) {
                    addSigningComment(value as string);
                }
            });
        }
        setChangeComments({
            premiumSum: '',
            productionStep: '',
            collectionStep: '',
            protectionStep: '',
            lackOfClaimsStep: '',
            documentsStep: '',
            sendingToCustomerStep: '',
            status: '',
        });
        setHasChanges(false);
    }

    const onUpdate = () => {
        console.log('onUpdate-signingItem', signingItem)
        if (props.actions && props.actions.update) {
            props.actions.update(signingItem);
            Object.entries(changeComments).forEach(([key, value]) => {
                console.log(`${key}: ${value}`);
                if (value && typeof value === 'string' && value.length > 0) {
                    addSigningComment(value as string);
                }
            });
        }
    }


    const onAddOfferOptionClick = async (type: number) => {

        const res = await new ProductionModel().GetSigningData(signingItem.id);
        if (res) {
            console.log('onAddOfferOptionClick-res', res.policy)
            console.log('onAddOfferOptionClick-showAddTreatmentPopup-sign', signingItem.id)
            if (props.actions.showAddTreatmentPopup) {
                console.log('onAddOfferOptionClick-showAddTreatmentPopup-sign-inside', signingItem.id)
                props.actions.showAddTreatmentPopup(res.policy.customerId, '', type);
            }
            dispatch(setCreateTreatmentFrom({ type: 'sign', id: signingItem.policyId }));
            dispatch(setSueInsuranceCompanyId(res.policy?.insuranceCompanyId ? res.policy.insuranceCompanyId : ""));
        }
    }



    const buildMenuOptions = async () => {

        const menuOptions: MenuProps['items'] = [];
        if (hasChanges && props.actionBtns) {
            menuOptions.push(
                {
                    label:
                        <li className="pointer rtl"
                            onClick={() => onSaveChanges()}
                        >
                            שמור שינוים
                        </li>,
                    key: 'sendChanges',
                    disabled: !hasChanges
                }
            );
        }
        if (props.actionBtns == true) {
            menuOptions.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('assignToHandler') }}
                    >
                        שיוך לחתמת
                    </li>,
                key: 'assignToHandler',
            })
            menuOptions.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { onAddOfferOptionClick(TreatmentType._1) }}>
                        יצירת משימה
                    </li>,
                key: 'createTreatment',
            })
        }
        menuOptions.push({
            label:
                <li className="pointer rtl"
                    onClick={() => { onMenuClicked('redirectToClient') }}
                >
                    מעבר ללקוח
                </li>,
            key: 'redirectToClient',
        })

        if (isAdmin) {
            menuOptions.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { onMenuClicked('delete') }}
                    >
                        מחק
                    </li>,
                key: 'delete',
            })
        }
        setSigningMenuOptions(menuOptions);




        const riderMenuOptions: MenuProps['items'] = [];
        riderMenuOptions.push(
            {
                label:
                    <li className="pointer rtl"
                        onClick={(e: any) => onRiderRowClick(e)}
                    >
                        צפיה
                    </li>,
                key: '1',
                //disabled: !hasChanges
            }
        );

        if (signingItem.rider && signingItem.rider.riderStatusType == 3 && props.actionBtns) {
            riderMenuOptions.push(
                {
                    label:
                        <li className="pointer rtl"
                            onClick={onUpdatePaymentsClick}
                        >
                            ערוך תשלום
                        </li>,
                    key: '2',
                    //disabled: !hasChanges
                }
            );
        }
        if (signingItem.rider && signingItem.rider.riderStatusType == 3 && props.actionBtns) {
            riderMenuOptions.push(
                {
                    label:
                        <li className="pointer rtl"
                            onClick={onActivateRiderClick}
                        >
                            הפעלת ריידר                    </li>,
                    key: '3',
                    //disabled: !hasChanges
                }
            );
        }
        riderMenuOptions.push(
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { onAddOfferOptionClick(TreatmentType._1) }}>
                        יצירת משימה לריידר
                    </li>,
                key: '4',
            }
        )
        setRiderMenuOptions(riderMenuOptions);
    }

    const calcRiderPremia = () => {
        if (riderItem.riderPackages && riderItem.riderPackages.length > 0) {
            let totalCustomerCost: number = 0;
            riderItem.riderPackages.forEach((p: any) => {
                totalCustomerCost += p.customerCost
            })
            return (totalCustomerCost);
        }
        return 0;

    }

    const getSeen = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        const userData = loggedUser ? JSON.parse(loggedUser) : {}
        if (signingItem.status != 1 && signingItem.signingUserId == userData.id)
            return true;
        return false
    }

    const getSeenRider = () => {
        let loggedUser: any = localStorage.getItem('loggedUser');
        const userData = loggedUser ? JSON.parse(loggedUser) : {}

        if (riderItem.riderStatusType == 3 && riderItem.underwriterUserId == userData.id)
            return true;
        return false
    }

    const emptyFunc = () => { }

    useEffect(() => {
        // Don't overwrite local state if there are unsaved changes
        if (hasChanges) return;

        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        // console.log('SigningItem -> props changed')
        if (props.config.additionalColumns) {
            setAdditionalColumns(props.config.additionalColumns);
        }
        const signingItem = props.details;
        if (signingItem.rider) {
            setRiderItem(signingItem.rider);
        }
        if (signingItem.elementaryPolicyStatusId && props.statuses) {
            const selectedStatus = props.statuses.find((s: any) => s.value === signingItem.elementaryPolicyStatusId);
            if (selectedStatus) {
                setStatusId(selectedStatus.value)
            }
        }
        signingItemRef.current = signingItem;
        setSigningItem(signingItem);
        setProductionCheck(signingItem.productionStep ? signingItem.productionStep : false);
        setCollectionCheck(signingItem.collectionStep ? signingItem.collectionStep : false);
        setDocumentsCheck(signingItem.documentsStep ? signingItem.documentsStep : false);
        setLackOfClaimsCheck(signingItem.lackOfClaimsStep ? signingItem.lackOfClaimsStep : false);
        setProtectionCheck(signingItem.protectionStep ? signingItem.protectionStep : false);
        setSendingToCustomerCheck(signingItem.sendingToCustomerStep ? signingItem.sendingToCustomerStep : false);
    }, [props.details])

    useEffect(() => {
        buildMenuOptions();
    }, [isAdmin, hasChanges])

    useEffect(() => {
        const signingItem = props.details;
        signingItemRef.current = signingItem;
        setSigningItem(signingItem);
        setProductionCheck(signingItem.productionStep ? signingItem.productionStep : false);
        setCollectionCheck(signingItem.collectionStep ? signingItem.collectionStep : false);
        setDocumentsCheck(signingItem.documentsStep ? signingItem.documentsStep : false);
        setLackOfClaimsCheck(signingItem.lackOfClaimsStep ? signingItem.lackOfClaimsStep : false);
        setProtectionCheck(signingItem.protectionStep ? signingItem.protectionStep : false);
        setSendingToCustomerCheck(signingItem.sendingToCustomerStep ? signingItem.sendingToCustomerStep : false);

        setShowOnlyRiders(props.config.showOnlyRiders ? true : false);

        let isAdmin = false;
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            isAdmin = loggedUser.role == 0;
            setIsAdmin(isAdmin);
            // setCurrentUser(loggedUser);
        }
        setIsAdmin(isAdmin);
    }, [])

    useEffect(() => {
        if (props.config.additionalColumns) {
            setAdditionalColumns(props.config.additionalColumns);
        }
    }, [props.config.additionalColumns])

    

    const getCarInfo = async (licenseNumber: string) => {
        if (licenseNumber && licenseNumber !== '') {
            const vehicle: any = await new SimulatorModel().getVehicleDetailsByLicenseNumber(licenseNumber);
            if (vehicle) {
                return `
                <div>חברה: ${vehicle.manufacturer && vehicle.manufacturer.label}</div>
                <div>דגם: ${vehicle.vehicleModel && vehicle.vehicleModel.label}</div>
                <div>תת דגם : ${vehicle.vehicleSubModel && vehicle.vehicleSubModel.label}</div>
                `;

            }
        }
    }

    const onHandlerCheckBoxRider = (e: any, riderId: string = '') => {
        props.handleCheckBoxRiderChange(e, props.index, riderId);
    }

    const closeStatuses = [
        "cc68852c-e281-40bd-94a9-f17bb8527420",
        "8928e341-e000-4d25-b2bc-440ed1e98ce4",
        "4417fea8-6401-4125-97fc-d3281bb79306",
    ];

    return (
        <>
            {
                showErrorPopUp &&
                <SignMessagePopUp
                    messageTitle={"שגיאה"}
                    messageContent={"לא ניתן לעדכן שדה זה לפני שמספר פוליסה הוזן."}
                    ShowHidePopup={(status: boolean) => setShowErrorPopUp(status)}
                    ClosePopup={() => setShowErrorPopUp(false)}
                />
            }
            {!showOnlyRiders && (hasChanges || (props.showOnlyOpens && !closeStatuses
                .map(id => id.toLowerCase()).includes(signingItem.elementaryPolicyStatusId.toLowerCase())) || !props.showOnlyOpens)
                && <Dropdown menu={{ items: signingMenuOptions }} trigger={['contextMenu']}>
                    <div className={`sing-details-row ${hasChanges ? 'row-has-changes' : ''} ${getSeen() ? 'unseen' : ''}`} onClick={(e: any) => onRowClick(e)}
                        style={{ border: props.borderBold ? '3px solid #017bfd78' : '3px solid #b2afafed' }}>
                        {/* <div className="cell icon-cell">
                        </div> */}
                        <div className="row-cell client-name" title='שם'>
                            <div className="description cell-value" style={{ fontWeight: 'bold' }}>
                                <>
                                    {signingItem.fullName}
                                    {signingItem.offerIdentity}
                                </>
                            </div>
                        </div>
                        <div className={`row-cell client-id on-click-ignore ${!additionalColumns || !additionalColumns.includes("ת.ז.") ? 'hide' : ''}`} title='תז/חפ'>
                            <div className="description cell-value">
                                {signingItem.identifier}
                            </div>
                        </div>
                        <div className={`row-cell production ${!additionalColumns || !additionalColumns.includes("סוג הפקה") ? 'hide' : ''}`} title='הפקה'>
                            <div className="description cell-value">
                                {signingItem.productionMode}
                            </div>
                        </div>
                        <div className="row-cell insurance-company" title='חברת ביטוח'>
                            <div className="description cell-value">
                                {signingItem.insuranceCompanyName}
                            </div>
                        </div>
                        <div className="row-cell policy-type" title='סוג פוליסה  '>
                            <div className="description cell-value flex-start">
                                <div className="icon policy-type vehicle"></div>
                                {signingItem.policyTypeName}
                            </div>
                        </div>
                        <div className="row-cell route-id" title='ענף'>
                            <div className="description cell-value">
                                {signingItem.routeId}
                            </div>
                        </div>
                        <div className="row-cell route-name">
                            <div className="description cell-value">
                                {signingItem.routeName}
                                {(signingItem.elementaryPolicy && signingItem.elementaryPolicy.offer.additionalDetails && signingItem.elementaryPolicy.offer.additionalDetails.indexOf('coverage10000\':true') != -1 ? " 10000" : "")}
                            </div>
                        </div>
                        <div className="row-cell insurance" title={`ביטוח ${signingItem.vehiclePolicyType}`}>
                            <div className="description cell-value">
                                {signingItem.vehiclePolicyType}
                            </div>
                        </div>
                        <div className="row-cell premia" title={`פרמיה`}>
                            <div className="description cell-value">
                                {signingItem.premium ?
                                    (<>
                                        &#8362;{signingItem.premium}
                                    </>) : (<></>)}
                            </div>
                        </div>
                        <div className="row-cell event" title='אירוע'>
                            <div className="description cell-value">
                                {signingItem.eventType}
                            </div>
                        </div>
                        <div className="row-cell license-id on-click-ignore" title='הנכס'>
                            <div className="description cell-value">
                                {signingItem.vehicle && signingItem.vehicle.licenseNumber ?
                                    <div>
                                        <div className='inner-row'>
                                            <span className='title'>
                                                רישוי:
                                            </span>
                                            {" " + signingItem.vehicle.licenseNumber}
                                        </div>
                                        <div className='inner-row'>
                                            <span className='title'>
                                                קוד דגם:
                                            </span>
                                            {" " + signingItem.vehicle.modelCode}
                                        </div>

                                    </div>
                                    : <></>}
                            </div>
                        </div>
                        <div className="row-cell policy-number on-click-ignore" title='מס פוליסה '>
                            <div className="description cell-value">
                                {signingItem.policyNumber}
                            </div>
                        </div>
                        <div className="row-cell signDate" title='תאריך יצירה '>
                            <div className="description cell-value">
                                {signingItem.startDate ? <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                    <span>{moment(signingItem.startDate).format('DD-MM-YYYY')}</span>
                                    <span style={{ color: 'gray', marginRight: '20px' }}>{moment(signingItem.startDate).format('HH:mm')}</span>
                                </div> : <></>}
                            </div>
                        </div>
                        <div className="row-cell alertDate" title='תאריך סיום '>
                            <div className="description cell-value">
                                {signingItem.endDate ? <>
                                    {moment(signingItem.endDate).format('DD-MM-YYYY')}
                                </> : <></>}

                            </div>
                        </div>
                        <div className="row-cell prod-hours" title='שעת יעד להפקה'>
                            <div className="description cell-value">
                                {signingItem.endDate ? <>
                                    {moment(signingItem.endDate2).format('HH:mm')}
                                </> : <></>}
                            </div>
                        </div>
                        <div className="row-cell creator" title='חתמת'>
                            <div className="description cell-value">
                                {signingItem.signingUserName}
                            </div>
                        </div>
                        <div className="row-cell creator" title='נוצר ע"י'>
                            <div className="description cell-value">
                                {signingItem.creatorFullName}
                            </div>
                        </div>
                        <div className={`row-cell checkBox-cell`} title='הפקה'>
                            <div className="description cell-value checkbox">
                                <input type='checkbox' className='pointer checkbox' checked={productionCheck} onChange={(e: any) => handleCheckChange('productionStep', e)} />
                            </div>
                        </div>
                        <div className={`row-cell checkBox-cell`} title='גביה'>
                            <div className="description cell-value checkbox">
                                <input type='checkbox' className='pointer checkbox' checked={collectionCheck} onChange={(e: any) => handleCheckChange('collectionStep', e)} />
                            </div>
                        </div>
                        <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("מיגון") ? 'hide' : ''}`} title='מיגון'>
                            <div className="description cell-value checkbox">
                                <input type='checkbox' className='pointer checkbox' checked={protectionCheck} onChange={(e: any) => handleCheckChange('protectionStep', e)} />
                            </div>
                        </div>
                        <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("ה. תביעות") ? 'hide' : ''}`} title='ה. תביעות'>
                            <div className="description cell-value checkbox">
                                <input type='checkbox' className='pointer checkbox' checked={lackOfClaimsCheck} onChange={(e: any) => handleCheckChange('lackOfClaimsStep', e)} />
                            </div>
                        </div>
                        <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("מסמכים") ? 'hide' : ''} checkbox`} title='מסמכים'>
                            <div className="description cell-value">
                                <input type='checkbox' className='pointer checkbox' checked={documentsCheck} onChange={(e: any) => handleCheckChange('documentsStep', e)} />
                            </div>
                        </div>
                        <div className={`row-cell checkBox-cell ${!additionalColumns || !additionalColumns.includes("שליחה") ? 'hide' : ''} checkbox`} title='שליחה'>
                            <div className="description cell-value">
                                <input type='checkbox' className='pointer checkbox' checked={sendingToCustomerCheck} onChange={(e: any) => handleCheckChange('sendingToCustomerStep', e)} />
                            </div>
                        </div>
                        <div className="row-cell icon-comment" title='comment'>
                            <div className="description cell-value">
                                <Tooltip title={signingItem.comment} color={'#027BFD'} placement="right">
                                    <div className="icon comment" onClick={emptyFunc}></div>
                                </Tooltip>
                            </div>
                        </div>
                        <div className="row-cell status" title='סטטוס'>
                            <div className="description cell-value">
                                <Select
                                    value={statusId}
                                    style={{ width: '140px' }}
                                    options={[
                                        {
                                            label: 'חדש',
                                            value: '0'
                                        },
                                        ...(props.statuses ? props.statuses : [])
                                    ]}
                                    onChange={onStatusChange}
                                    disabled={props.actionBtns ? false : true}
                                />
                            </div>
                        </div>
                        <div className={`row-cell creator ${!additionalColumns || !additionalColumns.includes("סוכן") ? 'hide' : ''}`} title='סוכן'>
                            <div className="description cell-value">
                                { }
                            </div>
                        </div>
                        <div className={`row-cell creator ${!additionalColumns || !additionalColumns.includes("קבוצת לקוחות") ? 'hide' : ''}`} title='קבוצת לקוחות'>
                            <div className="description cell-value">

                            </div>
                        </div>
                        <div className="row-cell actions on-click-ignore">
                            <Dropdown menu={{ items: signingMenuOptions }}>
                                <div className="act-btn-icon icon menu-hamburger pointer"></div>
                            </Dropdown>
                        </div>
                    </div>
                </Dropdown>}
            {riderItem &&
                <RiderItem borderBold={props.borderBold} riderMenuOptions={riderMenuOptions} riderItem={riderItem} additionalColumns={additionalColumns} handleCheckBoxRiderItemChange={onHandlerCheckBoxRider} fromSignsPolicy={true} />

            }
        </>
    )
}

export default SigningItem;